import type { ResourceLanguage } from 'i18next';

import type { Language } from '@/shared/i18n/languages';

/**
 * The modules' translations are not part of the main bundle: each language is one chunk with the texts of every module
 * (`modules/<id>/locales/<language>.json`, discovered by convention like the modules themselves), loaded before the
 * first render and when the user switches the language (docs/ARCHITECTURE.md §6.5).
 */
const bundles: Record<Language, () => Promise<{ default: Record<string, ResourceLanguage> }>> = {
  ru: () => import('./bundles/ru'),
  en: () => import('./bundles/en'),
  uk: () => import('./bundles/uk'),
};

export async function loadModuleLocales(language: Language): Promise<Record<string, ResourceLanguage>> {
  return (await bundles[language]()).default;
}
